import { Component, Input } from '@angular/core';
import { SummaryTableEntry } from '../../context-discovery-services/models/summary-table-entry.model';
import * as _ from 'lodash';

@Component({
  selector: 'adminapp-summary-controllers',
  templateUrl: './summary-controllers.component.html',
  styleUrls: ['./summary-controllers.component.scss']
})
export class SummaryControllersComponent {

  controllerList = new Array<SummaryTableEntry>();

  @Input()
  isLoading = false;

  @Input()
  set controllers(controllers: Array<any>) {
    if (!controllers || controllers.length === 0) {
      return;
    }

    const temp = [];
    _.each(controllers, function (controller) {
      temp.push(new SummaryTableEntry(controller.type, controller.count));
    });

    this.controllerList = temp;
  }

  constructor() { }

}
